export default __webpack_public_path__ + "static/media/OffIcon.9d429ff8.svg";